import React from 'react'
// ANT DESIGN
import {
    Input,
    Typography,
    Form,
    Col,
    Row,
  } from "antd";

  
const { Text, Title } = Typography;

const GlobalDetailView = (props) => {
    const { inputField, colNo } = props;
    return (
      <Row>
        {inputField.map((item, index) => (
          <Col
            span={colNo ? colNo : 8}
            style={{ padding: "0px 8px" }}
            key={index}
          >
            <Form.Item label={<Text strong>{item.name}</Text>}>
              <Input disabled value={item.value} className="of-bold-disable-input"/>
            </Form.Item>
          </Col>
        ))}
      </Row>
    );
}

export default GlobalDetailView